import api from "./api";

// Categorias e campos
export const listCategories = () => api.get("/ticket-categories");
export const listCategoryFields = (categoryId) => api.get(`/ticket-categories/${categoryId}/fields`);

// Detalhes do ticket
export const getTicketDetails = (id) => api.get(`/tickets/${id}/details`);
export const updateTicketDetails = (id, payload) => api.put(`/tickets/${id}/details`, payload);

// Atribuídos
export const listAssignees = (id) => api.get(`/tickets/${id}/assignees`);
export const replaceAssignees = (id, userIds) => api.put(`/tickets/${id}/assignees`, { userIds });
export const addAssignee = (id, userId) => api.post(`/tickets/${id}/assignees`, { userId });
export const removeAssignee = (id, userId) => api.delete(`/tickets/${id}/assignees/${userId}`);

// Comentários
export const listComments = (id, page = 1, pageSize = 20) => api.get(`/tickets/${id}/comments`, { params: { page, pageSize } });
export const addComment = (id, message, isInternal = false) => api.post(`/tickets/${id}/comments`, { message, isInternal });
export const editComment = (id, commentId, message, isInternal) => api.put(`/tickets/${id}/comments/${commentId}`, { message, isInternal });
export const removeComment = (id, commentId) => api.delete(`/tickets/${id}/comments/${commentId}`);

// Checklist
export const listChecklists = (id) => api.get(`/tickets/${id}/checklists`);
export const createChecklist = (id, title) => api.post(`/tickets/${id}/checklists`, { title });
export const updateChecklist = (checklistId, data) => api.patch(`/checklists/${checklistId}`, data);
export const deleteChecklist = (checklistId) => api.delete(`/checklists/${checklistId}`);
export const addChecklistItem = (checklistId, title, description) =>
  api.post(`/checklists/${checklistId}/items`, { title, ...(description ? { description } : {}) });
export const updateChecklistItem = (itemId, data) => api.patch(`/checklist-items/${itemId}`, data);
export const deleteChecklistItem = (itemId) => api.delete(`/checklist-items/${itemId}`);
export const applyChecklistTemplate = (ticketId, templateId) => api.post(`/tickets/${ticketId}/checklists/apply-template`, { templateId });

// Workflow state
export const updateWorkflowState = (ticketId, workflowState) => api.patch(`/tickets/${ticketId}/workflow`, { workflowState });

export default {
  listCategories,
  listCategoryFields,
  getTicketDetails,
  updateTicketDetails,
  listAssignees,
  replaceAssignees,
  addAssignee,
  removeAssignee,
  listComments,
  addComment,
  editComment,
  removeComment,
  listChecklists,
  createChecklist,
  updateChecklist,
  deleteChecklist,
  addChecklistItem,
  updateChecklistItem,
  deleteChecklistItem,
  applyChecklistTemplate
  ,updateWorkflowState
};
